// removed by extract-text-webpack-plugin
module.exports = {"title":"DGWSq5jzsE7u0BoP4NOa2","boxMessage":"_18pf5PS2xDjDUlRGc0GAo-","label":"_3Nbz3mJaixvEPqBPEJX4aT","trash":"_1HJsTEcqw4nhgJ186MfdPE","rounded":"_1BIBPUKP-2WeEXYVzFVmTp","setImage":"_3xX_V1QzP2MWuIx8YhEUYK","file":"_5nEWkTGOhjtxarWonctGf","divider":"_3-UWidI3K3aNtgn0FMFaVO","messageInfo":"FOdi7h9SZjvBsLndC29N7"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateProduct/style.module.css
// module id = 529
// module chunks = 39